var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 8 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.4 15.05v-6.8H0v-2.4h2.4V3.6C2.4 1.35 3.75 0 5.75 0c.95 0 1.75.1 2 .15V2.7h-1.6c-1.1 0-1.3.55-1.3 1.3v1.85h2.8l-.4 2.4h-2.4v6.8z"
  })));
};
export default SvgSocialFacebook;